import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateStockDiscountController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";


function CreateSupplierHistory({ modalInstance, currentStockDiscount, onClose, onSuccess, DiscountTypeList, PartID }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    const [formData, setFormData] = useState({
        FK_Stock_ID: PartID, snt_Order: '0', snt_QuantityBreak: '0', dec_Discount: '0.00'
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (currentStockDiscount) {
            setFormData({
                ID: currentStockDiscount.PK_Discount_ID, FK_Stock_ID: PartID, snt_Order: currentStockDiscount.snt_Order,
                snt_QuantityBreak: currentStockDiscount.snt_QuantityBreak, dec_Discount: currentStockDiscount.dec_Discount,
                FK_StockCategory_ID: currentStockDiscount.FK_StockCategory_ID
            });
        } else {
            setFormData({
                FK_Stock_ID: PartID, snt_Order: '0', snt_QuantityBreak: '0', dec_Discount: '0.00', FK_StockCategory_ID: 0
            });
        }
    }, [currentStockDiscount]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);

        const { name, value } = event.target;
        let updatedFormData = { ...formData, [name]: value };

        // Validate dec_Quantity field to allow only decimal values
        if (name === 'snt_QuantityBreak') {
            // Check if the input is a valid decimal number
            if (/^\d+$/.test(value)) {
                updatedFormData.snt_QuantityBreak = value;
            } else {
                // If the input is not a valid decimal number, reset the field to the previous value
                updatedFormData.snt_QuantityBreak = formData.snt_QuantityBreak || '';
            }
        }
        if (name === 'dec_Discount') {
            // Check if the input is a valid decimal number
            if (/^\d*\.?\d*$/.test(value)) {
                updatedFormData.dec_Discount = value;
            } else {
                // If the input is not a valid decimal number, reset the field to the previous value
                updatedFormData.dec_Discount = formData.dec_Discount || '';
            }
        }
        setFormData(updatedFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault();

        if (currentStockDiscount) {
            formData.ID = currentStockDiscount.PK_Discount_ID;
            formData.snt_Order = "0";
        } else {
            formData.ID = 0;
            formData.snt_Order = "0";
        }

        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess();
        }, () => {
            onSuccess();

        });
    };


    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade stockDiscountModal show d-block" id="stockDiscountModal" tabIndex="-1" aria-labelledby="stockDiscountModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{currentStockDiscount ? "Edit Discount" : "Add Discount"}</h5>
                                <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "10px", "marginTop": "10px" }}>
                                    <label htmlFor="DiscountTypeID" className="col-sm-2 col-form-label">Discount Categories</label>
                                    <div className="col-sm-4">
                                        <select
                                            name="FK_StockCategory_ID"
                                            className='form-control'
                                            value={formData.FK_StockCategory_ID}
                                            onChange={handleFieldChange}>
                                            <option value="0">Select Discount Categories</option>
                                            {DiscountTypeList.map((discount) => (
                                                <option key={discount.PK_StockCategory_ID} value={discount.PK_StockCategory_ID}>
                                                    {discount.vc_Name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="snt_QuantityBreak" className="col-sm-2 col-form-label">Quantity Break</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="snt_QuantityBreak" value={formData.snt_QuantityBreak} onChange={handleFieldChange} disabled={formData.snt_CommunicationType === '0'} />
                                        {errors.snt_QuantityBreak && <div style={{ color: 'red' }}>{errors.snt_QuantityBreak}</div>}
                                    </div>
                                    <label htmlFor="dec_Discount" className="col-sm-2 col-form-label">Discount</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="dec_Discount" value={formData.dec_Discount} onChange={handleFieldChange} disabled={formData.snt_CommunicationType === '0'} />
                                        {errors.dec_Discount && <div style={{ color: 'red' }}>{errors.dec_Discount}</div>}
                                    </div>
                                </div>

                            </div>

                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                   <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> {currentStockDiscount ? " Update" : " Save"}
                                </button>
                                <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                   <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}
export default CreateSupplierHistory;
